import gql from "graphql-tag"

const socialsHandle = gql`
  fragment SocialsHandle on SocialsHandle {
    id
    accountId
    did
    handle
    displayName
    avatarUrl
    description

    followerCount
    followingCount
    followsYou
    youFollow
    isMutual
    relationshipState

    followBackRatio
    score
    topicScore

    outboundAmplification
    outboundReshareRate
    topicTags
    lastPostAt
    latestInteractedAt
    lastSyncedAt
    lastScoredAt

    notes
    isIgnored
    manualPriority

    createdAt
    updatedAt
  }
`

export default socialsHandle
